import Colors from './colors'

const Theme = {
  colors: Colors
}

export default Theme
